<app-step-progress [steps]="steps"></app-step-progress>
<div *ngIf="userOrderStatusDto?.userOrderStatus === approvedStatusNumber">
    <app-approved-payment
        [userOrderStatusDto]="userOrderStatusDto"
        [brandId]="brandId"
        [orderNumber]="orderNumber"
    ></app-approved-payment>
</div>
<div *ngIf="orderIncompleted">
    <app-incomplete-order
        [isRegFlow]="true"
        [brandId]="brandId"
    ></app-incomplete-order>
</div>
